import React, { useState } from 'react';
import SEO from './common/SEO';
import Slider from 'react-slick';

// Testimonial data array
const data = [
    {
        name: "Kajal Bothra",
        details: "I am an employee of FETC, and my visa application was successfully approved under the guidance of Bhumika Mam. This experience has not only strengthened my confidence but also equipped me with valuable insights into the embassy process, which I can now use to guide our clients effectively. I am grateful for the support and guidance throughout this process.",
        designation: "Visa Category: USA B1/B2 Visa",
        image: "testimonial1.jpg"
    },
    {
        name: "Jigar Shah & Family",
        details: "Thank you, FETC, for your incredible support! Special thanks to you for keeping me positive and calm during the process of obtaining visas for me and my family. Your guidance and encouragement made a significant difference. Thanks again to the entire team, especially Bhumika, for their exceptional assistance.",
        designation: "Visa Category: Australia Visitor Visa",
        image: "testimonial2.jpg"
    },
    {
        name: "Dharmendra Lad & Family",
        details: "We are delighted to inform you that we have successfully obtained our visa! Thank you so much for your invaluable guidance and support throughout the process. Securing the earliest visa slot and assisting us with the visa documentation made the entire process remarkably smooth. Your preparation for the visa interview was incredibly helpful, and we truly appreciate your expertise and dedication. The best part is that I will now be able to attend my child's convocation. Thank you FETC for everything.",
        designation: "Visa Category: USA B1/B2 Visa",
        image: "testimonial3.jpg"
    },
    {
        name: "Prajal Sonariya",
        details: "FETC has been instrumental in shaping my profile, allowing me to focus on honing my musical skills with minimal effort on my part. Their comprehensive support included SOP writing, preparing financial documents, conducting visa mock interviews, and even securing visa dates. Thanks to their assistance, I successfully gained admission and obtained my visa. I am extremely grateful for their help.",
        designation: "Visa Category: USA Student Visa Approved",
        image: "testimonial4.png"
    },
    {
        name: "Dhaval Pokiya, Jenika Pokiya & Shriyan Pokiya",
        details: "I, Dhaval Pokiya, want to thank you for successfully attaining USA tourist visas for my children, and ours earlier. After my experience, I am confident that FETC can handle any visa queries and ensure a smooth process. We are so happy to be able to travel to the USA as a family!",
        designation: "Visa Category: USA B1/B2 Visa",
        image: "testimonial5.jpg"
    },
    {
        name: "Shaswat Maheshwari",
        details: "I am thrilled to share that I have successfully obtained my UK visitor visa to visit my sister. During this challenging era for visa approvals, I am especially grateful to FETC for their invaluable assistance in making the application process smooth and efficient. Thank you, FETC, for your support and expertise.",
        designation: "Visa Category: UK Visitor Visa",
        image: "testimonial6.jpg"
    },
    {
        name: "Udit Gagnani",
        details: "I had an excellent experience with FETC From the start, they provided a comprehensive list of all required documents and clearly explained the entire application process. They also meticulously detailed each stamp needed to validate the documents for my visa application. Their step-by-step guidance and professional support made the complex process straightforward and stress-free. Their attention to detail and dedication ensured everything was in order, which gave me great confidence in my application. I highly recommend FETC for their exceptional and thorough service.",
        designation: "Visa Category: Fully Funded Free Education Italy Student Visa",
        image: "testimonial7.png"
    },
    {
        name: "Samarth Pachchigar",
        details: "I couldn't be more satisfied. The overall process was incredibly smooth, thanks to their efficient and knowledgeable team. While visa processes are usually a hassle, FETC ensured everything went seamlessly for us. Their professionalism and attention to detail made a significant difference, and I highly recommend their services to anyone seeking a stress-free experience with their education abroad process.",
        designation: "Visa Category: Spain Student Visa",
        image: "testimonial8.png"
    },
];

const Testimonial = () => {
    const [testimonialNav, setTestimonialNav] = useState();
    const [testimonialThumb, setTestimonialThumb] = useState();

    return (
        <>
            <SEO title="Testimonial" />
              
            <div className="eduvibe-home-two-testimonial edu-testimonial-area testimonial-card-box-bg edu-section-gap bg-image">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <div className="section-title text-center">
                                <span className="pre-title">Testimonial</span>
                                <h3 className="title">Our Clients Feedback</h3>
                            </div>
                        </div>
                    </div>
                    <div className="edu-testimonial-activation testimonial-item-3 mt--40 edu-slick-button">
                        <Slider 
                            asNavFor={testimonialNav}
                            ref={(slider1) => setTestimonialNav(slider1)}
                            focusOnSelect={true}
                            speed={500}
                            slidesToShow={1}
                            slidesToScroll={1}
                            arrows={false}
                            dots={true}
                        >
                            {data.map((item, i) => (
                                <div className="testimonial-nav-content" key={i}>
                                    <p className="description">“ {item.details} ”</p>
                                    <div className="client-info">
                                        <h6 className="title">{item.name}</h6>
                                        <span className="designation">{item.designation}</span>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className="edu-testimonial-thumbnail mt--40">
                        <Slider
                            className="testimonial-nav-button"
                            asNavFor={testimonialNav}
                            ref={(slider2) => setTestimonialThumb(slider2)}
                            focusOnSelect={true}
                            slidesToShow={3}
                            slidesToScroll={1}
                            arrows={true}
                            centerMode={true}
                        >
                            {data.map((item, i) => (
                                <div className="thumbnail thumbnail-text-align" key={i}>
                                    <div className="circle-image-wrapper">
                                        <img className="radius-round" style={{ height: '150px' }} src={`${process.env.PUBLIC_URL}/images/testimonial/testimonial-02/${item.image}`} alt="Testimonial Section Thumb" />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Testimonial;
